import Modal from "./Modal"

function CollarInfoModal({
  serial,
  isOpen,
  onClose,
}: {
  serial?: string
  isOpen: boolean
  onClose: () => void
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div>
        <h2 style={{ marginBottom: "2.2rem" }}>Serial: </h2>
        <p style={{ marginBottom: "0.8rem" }}>{serial}</p>
      </div>
    </Modal>
  )
}

export default CollarInfoModal
